import '@styles/cart.scss';

import { RepurchaseWarningModal } from '@src/Component/Modal/RepurchaseWarningModal';
import { SetContentsModal } from '@src/Component/Modal/SetContentsModal';

import { AbandonCartLookout } from '@src/Service/AbandonCartLookout';
import { LocationProxy } from '@src/Service/LocationProxy';

import { RippleButtonCoordinator } from '@src/Service/RippleButtonCoordinator';
import { CsrfTokenProvider } from '@src/Service/CsrfTokenProvider';

import { TemplateFactory } from '@src/Service/TemplateFactory';
import { BlankTemplateProvider } from '@src/Service/TemplateProvider/BlankTemplateProvider';

import { CartRepository } from '@src/Repository/CartRepository';

import { PageSpinner } from '@src/Component/PageSpinner';
import { CartReview } from '@src/Component/CartReview';

import { createOlsStore } from '@src/Redux/Store/OnlineStore';
import { waitFor, isLoading, forever } from '@src/Redux/Module/App';
import { getDuplicateProducts, getLineItems } from '@src/Redux/Module/Cart';

import { subscribeSelector } from '@src/Service/subscribeSelector';

import { RequestClient } from '@gleim/request-client';
import { EmbeddedDataRepository } from '@gleim/js-sync';
import { GlobalErrorHandler, pinRequestCallstack } from '@gleim/client-logging';

$(() => {
    new RippleButtonCoordinator();

    const location = new LocationProxy();
    const fallbackErrorHandler = new GlobalErrorHandler();
    fallbackErrorHandler.onErrorProcessed(() => location.assign('/error.php'));

    new AbandonCartLookout(location);

    const csrfTokenProvider = new CsrfTokenProvider();
    const apiClient = new RequestClient('/store/v1', csrfTokenProvider.fetchCurrentToken())
        .extend(pinRequestCallstack);
    const cartRepository = new CartRepository(apiClient);
    const dataRepository = new EmbeddedDataRepository();

    const templateFactory = new TemplateFactory([new BlankTemplateProvider()]);
    const busySpinner = new PageSpinner();

    const repurchaseModal = new RepurchaseWarningModal(templateFactory);
    const setContentsModal = new SetContentsModal();
    $('.set-contents-trigger').on('click', (event) => {
        setContentsModal.show($(event.currentTarget).siblings('.set-elements'));
    });

    if ($(document).has('#populated-cart')) {
        const store = createOlsStore({ cart: dataRepository.fetch('cart') });

        fallbackErrorHandler.onErrorCaught(() => store.dispatch(waitFor(forever)));

        location.onRedirect(() => store.dispatch(waitFor(forever)));
        subscribeSelector(store, isLoading, (loading) => (
            loading ? busySpinner.enable() : busySpinner.disable()
        ));

        const $cartReview = $('#populated-cart');

        new CartReview($cartReview, store, cartRepository, templateFactory, location);

        $('.checkout-for-self').on('click', () => {
            const target = '/store/checkout';
            const duplicateProducts = getDuplicateProducts(store.getState());

            if (duplicateProducts?.length > 0) {
                repurchaseModal.show(duplicateProducts, target);
            } else {
                location.assign(target);
            }
        });

        subscribeSelector(store, getLineItems, (lineItems) => {
            if (lineItems?.length === 0 || !lineItems) {
                $('#populated-cart').remove();
                $('#empty-cart').attr('hidden', null);
            }

            if (store.getState().cart.hasAnyReseller) {
                $('.checkout-as-gift').attr('hidden', null);
            } else {
                $('.checkout-as-gift').attr('hidden', '');
            }
        });
    }
});
